<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-card elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-when-relationship-ends.jpg"
            >
            </v-img>
            <v-card-title class="justify-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-2">When Your Relationship Ends</h3>
                <div v-if="product.unlocked" class="text-md-center teal--text mb-0">Already purchased.</div>
                <h3 v-else class="headline text-md-center teal--text mb-0">{{product.cost}}</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn v-if="product.unlocked" color="teal" dark @click="downloadEbook">Download</v-btn>
              <v-btn v-else color="teal" dark @click="showAlert">Buy</v-btn>
            </v-card-actions>
          </v-card>
      </v-col>
      <v-col cols="8">
        <h1 class="headline">How to best separate: When Your Relationship Ends (Practical Workbook)</h1>
        <p>Many people feel uncertain and unsure of what they should do when they separate. Then, when they are given the direction, they feel overwhelmed by the amount of information they have to absorb and action. This e-book is perfect for the newly separated individuals to guide them with what they need to do when their relationship ends.</p>
        <p>It is designed to help you reflect upon your relationship, guides you with the first essential steps so that you know you are moving in the right direction. You will learn who you need on your divorce team so that you are supported. It offers basic money management in divorce so that you protect your assets and preserve your funds for a later date. Learn how diarising can help you on your journey so that you have the right information when you need it and how to create financial independence so that you can create an amazing future.</p>
      </v-col>
    </v-row>
    <product-purchase-dialog
      :dialogVisible="dialogVisible"
      :test="product.test"
      :firstName="firstName"
      :lastName="lastName"
      :email="email"
      :productName="product.name"
      :amount="product.cost"
      :stripePriceId="product.stripePriceId"
      @input="didDismissDialog"
      :didCompletePurchase="didCompletePurchase"></product-purchase-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    productId: '26d5e815-0522-4525-9844-a1e9f58f9c57',
    dialogVisible: false,
    productImageURL: ''
  }),
  created () {
    this.$store.dispatch('products/view', this.productId)
  },
  computed: {
    product () {
      return this.$store.getters['products/loadedProduct']
    },
    loading () {
      return this.$store.getters.loading
    },
    firstName () {
      return this.$store.getters.user.firstName
    },
    lastName () {
      return this.$store.getters.user.lastName
    },
    email () {
      return this.$store.getters.user.email
    }
  },
  methods: {
    showAlert () {
      this.dialogVisible = true
    },
    didDismissDialog (value) {
      this.dialogVisible = false
    },
    didCompletePurchase (productId) {
      this.$store.dispatch('products/unlock', this.productId)
    },
    downloadEbook () {
      this.$store.dispatch('download/sign', this.product.downloadURL).then(protectedURL => {
        window.location = protectedURL
      })
    }
  }
}
</script>
